<template>
  <section class="case-studies">
    <AppHeader></AppHeader>
    <div id="top-content" class="container-fluid inner-page">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="page-title">How Businesses are using Verloop</div>
            <div class="page-subtitle">Read and find out how businesses are using Verloop</div>
          </div>
        </div>
      </div>
    </div>
    <div id="stories-list" class="container-fluid">
      <div class="container">
        <div class="row section-wrapper">
          <CaseStudyBrands
            image="nykaa.png"
            name="Nykaa"
            description="Nykaa, an Indian multi-brand beauty retailer selling cosmetic and wellness products,
          engaged
          99.7% of all its customers in under 1 minute using Verloop's Live Chat."
            link="/case-study-nykaa.html"
          ></CaseStudyBrands>
          <CaseStudyBrands
            image="apollomunich.jpg"
            name="Apollo Munich"
            description="Apollo Munich Insurance company, a joint venture between Apollo Hospitals Group and
          Munich
          Health, used Verloop to shorten its Sales Cycle by over 3X."
            link="/case-study-apollomunich.html"
          ></CaseStudyBrands>
          <CaseStudyBrands
            image="acadgild.png"
            name="Acadgild"
            description="Acadgild, which provides on-demand career development courses online, increased its
          overall
          conversion rates by 240% using Verloop's Live Chat."
            link="/case-study-acadgild.html"
          ></CaseStudyBrands>
        </div>
        <div class="row">
          <CaseStudyBrands
            image="o2-spa.png"
            name="O2 Spa"
            description="O2 Spa is Asia's largest day Spa chain. Currently open in 70 locations across 21
          cities in India, they rejuvenate over 2000 guests every day."
            link="/case-study-o2spa.html"
          ></CaseStudyBrands>
          <CaseStudyBrands
            image="MediBuddy.png"
            name="MediBuddy"
            description="MediBuddy is an award-winning platform that brings together the best of healthcare
          offered by a curated network of partners for all stakeholders in the ecosystem."
            link="/case-study-medibuddy.html"
          ></CaseStudyBrands>
          <CaseStudyBrands
            image="kaarva.png"
            name="Kaarva"
            description="Kaarva is an Indian fintech startup that democratizes payroll for salaried employees by offering
          instant salary advances with zero collateral and paperwork."
            link="/case-study-kaarva.html"
          ></CaseStudyBrands>
        </div>
        <div class="row">
          <CaseStudyBrands
            image="waterprojects.png"
            name="Water Projects"
            description="Ecuador's leading water purification companies, Culligan Water Projects S.A. provides sophisticated
        water treatment services for the entire country."
            link="/case-study-waterprojects.html"
          ></CaseStudyBrands>
          <CaseStudyBrands
            image="Marathon.png"
            name="Marathon Realty"
            description="With 50+ years of real estate experience under its belt, Marathon Realty has over 80 completed and ongoing projects across the Mumbai Metropolitan Region."
            link="/case-study-marathon.html"
          ></CaseStudyBrands>
        </div>
      </div>
    </div>
    <MoreInfo></MoreInfo>
    <AppFooter></AppFooter>
  </section>
</template>
<script>
import AppHeader from "@/components/Header/Header.vue";
import AppFooter from "@/components/Footer/Footer.vue";
import MoreInfo from "@/components/MoreInfo.vue";
import CaseStudyBrands from "@/views/CaseStudies/components/CaseStudyBrands.vue";

export default {
  name: "case-studies",
  components: {
    AppHeader,
    AppFooter,
    MoreInfo,
    CaseStudyBrands
  }
};
</script>
<style scoped lang="scss">
h4,
p {
  overflow-y: hidden;
}
</style>

